/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const List = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M3.66669 6C4.21897 6 4.66669 5.55228 4.66669 5C4.66669 4.44772 4.21897 4 3.66669 4C3.1144 4 2.66669 4.44772 2.66669 5C2.66669 5.55228 3.1144 6 3.66669 6Z"
                        fill={color}
                    />
                    <path d="M20.5 4.25H6.5V5.75H20.5V4.25Z" fill={color} />
                    <path d="M20.5 11.25H6.5V12.75H20.5V11.25Z" fill={color} />
                    <path d="M6.5 18.25H20.5V19.75H6.5V18.25Z" fill={color} />
                    <path
                        d="M4.66669 12C4.66669 12.5523 4.21897 13 3.66669 13C3.1144 13 2.66669 12.5523 2.66669 12C2.66669 11.4477 3.1144 11 3.66669 11C4.21897 11 4.66669 11.4477 4.66669 12Z"
                        fill={color}
                    />
                    <path
                        d="M3.66669 20C4.21897 20 4.66669 19.5523 4.66669 19C4.66669 18.4477 4.21897 18 3.66669 18C3.1144 18 2.66669 18.4477 2.66669 19C2.66669 19.5523 3.1144 20 3.66669 20Z"
                        fill={color}
                    />
                </svg>
        );
    };
